import React, { useState, useEffect } from "react";
import { FinishEmailBlock } from "./styled";
import { useSelector } from "react-redux";
import { EMAIL_PAYWALL_THEME_OBJ } from "../../../constants/data";
import {
  blackColor,
  greyTextColor,
  lightSecondColor,
  purpleSecondColor,
  whiteColor,
} from "../../../constants/colors";
import blueBg from "../../../resources/images/utils/blue.png";
import purpleBg from "../../../resources/images/utils/purple.png";
import mobileBg from "../../../resources/images/main/mobile_bg.png";
import { MainBlock } from "../../Main/styled";
import starsImg from "../../../resources/images/main/stars_bg_new.png";
import starsImgLight from "../../../resources/images/main/stars_bg_light.png";
import logo from "../../../resources/images/main/logo_new.svg";
import journeyText from "../../../resources/images/main/logo_text.svg";
import qrWhite from "../../../resources/images/info/QR_white.png";
import qrBlack from "../../../resources/images/info/QR_black.png";
import journeyTextBlack from "../../../resources/images/main/journey_text_black.svg";
import appleButtonLight from "../../../resources/images/info/apple_button_light.png";
import appleButtonDark from "../../../resources/images/info/apple_button_dark.png";
import { Container, Heading, Text } from "../../../styled";
import { useDeviceType } from "../../../hooks/useDeviceType";
import { FinishBlock } from "../styled";
import congrats from "../../../resources/images/main/congrats.png";
import congratsLight from "../../../resources/images/main/congrats_light.png";
import Button from "../../design_components/Button/Button";
import {
  createEventObjectFunction,
  redirectToStoreFunction,
} from "../../../utils/helper";
import { storeOpenEvent } from "../../../firebaseAnalytics/events";
import { analytics } from "../../../firebaseAnalytics";
import { storeOpenEventAmplitude } from "../../../amplitude/events";
import { QRCodeSVG } from "qrcode.react";

const FinishEmail = () => {
  const [theme, setTheme] = useState(null);
  const [isOpacity, setOpacity] = useState(true);

  const device = useDeviceType();

  const remoteConfig = useSelector((state) => state.questions.remoteConfig);
  const handleTheme = useSelector((state) => state.questions.theme);
  const landingId = useSelector((state) => state.questions.landingId);

  useEffect(() => {
    setTimeout(() => {
      setOpacity(false);
    }, 500);
  }, []);

  useEffect(() => {
    setConfigParameters();
  }, [remoteConfig]);

  const setColorDependTheme = (darkColor, lightColor) => {
    if (theme && theme === "dark") {
      return darkColor;
    } else {
      return lightColor;
    }
  };

  const setConfigParameters = () => {
    if (handleTheme === null) {
      setTheme(EMAIL_PAYWALL_THEME_OBJ[remoteConfig.paywallOfferId]);
    } else {
      setTheme(handleTheme);
    }
  };

  const handleButtonClick = () => {
    const eventObj = createEventObjectFunction(null, null, landingId);
    // Событие №6 store open
    storeOpenEvent(analytics, eventObj);
    storeOpenEventAmplitude(eventObj);
    redirectToStoreFunction();
    window.location.href = remoteConfig.storeLink;
  };

  return (
    <FinishEmailBlock
      style={{ background: setColorDependTheme(blackColor, "#E0DFF0") }}
    >
      {theme !== "dark" ? (
        <>
          <img className="blue" src={blueBg} alt="bg" />
          <img className="purple" src={purpleBg} alt="bg" />{" "}
        </>
      ) : (
        <MainBlock.Mobile>{/*<img src={mobileBg} alt="" />*/}</MainBlock.Mobile>
      )}
      <FinishEmailBlock.Top>
        <img
          className="stars"
          src={theme === "dark" ? starsImg : starsImgLight}
        />
        <div style={{ marginBottom: 11 }}>
          <img src={logo} style={{ width: 44, height: 44 }} alt="logo" />
        </div>
        {device !== "mobile" ? (
          <>
            <Heading
              style={{
                fontSize: 28,
                lineHeight: "36px",
                marginBottom: 4,
              }}
            >
              <span
                style={{
                  color: setColorDependTheme(lightSecondColor, blackColor),
                }}
              >
                Congratulations!
              </span>
            </Heading>
            <Text.Fourth
              style={{
                marginBottom: 10,
                zIndex: 2,
                position: "relative",
                color: setColorDependTheme(lightSecondColor, blackColor),
              }}
            >
              <span
                style={{
                  color: setColorDependTheme(lightSecondColor, blackColor),
                }}
              >
                You’re now a member of Journey{" "}
              </span>
              <span className={"premium"}>premium</span>
            </Text.Fourth>
          </>
        ) : (
          <img
            src={theme === "dark" ? journeyText : journeyTextBlack}
            alt="text"
            style={{ width: 100 }}
          />
        )}
      </FinishEmailBlock.Top>
      <FinishEmailBlock.Center>
        {device !== "mobile" ? (
          <>
            <Text.Third
              style={{
                color: setColorDependTheme(greyTextColor, purpleSecondColor),
                marginBottom: 34,
              }}
            >
              Please scan QR code below on your
              <br /> iPhone to get a special Journey link
            </Text.Third>
            <QRCodeSVG
              size={214}
              fgColor={theme === "dark" ? "#ffffff" : blackColor}
              bgColor={theme !== "dark" ? "rgb(224, 223, 240)" : blackColor}
              value={remoteConfig.storeLink}
            />
            {/*<img*/}
            {/*  style={{ width: 214 }}*/}
            {/*  src={theme === "dark" ? qrWhite : qrBlack}*/}
            {/*  alt="qr"*/}
            {/*/>*/}
          </>
        ) : (
          <>
            <FinishBlock.Img style={{ paddingTop: 20 }}>
              <img
                src={theme === "dark" ? congrats : congratsLight}
                alt="congrats"
              />
            </FinishBlock.Img>
            <FinishBlock.Gradient
              style={{
                transition: "0.5s",
                opacity: isOpacity ? 0 : 1,
                zIndex: 1,
                background:
                  theme === "dark"
                    ? "linear-gradient(180deg, rgba(5, 2, 55, 0) 0.01%, #050237 28.49%)"
                    : "linear-gradient(180deg, rgba(224, 221, 239, 0) 0%, #E0DEF0 28.92%)",
              }}
            />
            <Heading
              style={{
                marginBottom: 16,
                marginTop: -90,
                zIndex: 2,
                position: "relative",
                color: setColorDependTheme(lightSecondColor, blackColor),
              }}
              className="finish"
            >
              Congratulations!
            </Heading>
            <Text.Third
              style={{
                marginBottom: 10,
                zIndex: 2,
                position: "relative",
                color: setColorDependTheme(lightSecondColor, blackColor),
              }}
            >
              <span
                style={{
                  color: setColorDependTheme(lightSecondColor, blackColor),
                }}
              >
                You’re now a member <br />
                of Journey{" "}
              </span>
              <span className={"premium"}>premium</span>
            </Text.Third>{" "}
          </>
        )}
      </FinishEmailBlock.Center>
      <FinishEmailBlock.Bottom>
        <Container.Content>
          {device === "mobile" ? (
            <Button
              type={"default"}
              isGradient={theme !== "dark"}
              text={"Install Journey"}
              action={() => handleButtonClick()}
              color={{ color: setColorDependTheme(blackColor, whiteColor) }}
              style={{ background: theme === "dark" ? lightSecondColor : null }}
            />
          ) : (
            <>
              <img
                style={{ margin: "0 auto 20px auto", width: 178 }}
                onClick={() => handleButtonClick()}
                src={theme === "dark" ? appleButtonLight : appleButtonDark}
                alt="apple"
              />
              <Text.Fifth
                style={{
                  color: setColorDependTheme(greyTextColor, purpleSecondColor),
                }}
              >
                Please reach us <b>support@gojourney.app</b> <br /> if you have
                any questions.
              </Text.Fifth>
            </>
          )}
        </Container.Content>
      </FinishEmailBlock.Bottom>
    </FinishEmailBlock>
  );
};

export default FinishEmail;
